import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingScreen from '../common/LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredUserType?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredUserType 
}) => {
  const { user, token, hasuraToken, isLoading } = useAuth();
  const location = useLocation();

  // Show loading screen while checking authentication
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Redirect to login if not authenticated or missing required tokens
  if (!user || !token || !hasuraToken) {
    // console.log('ProtectedRoute: Authentication failed, redirecting to login', {
    //   user: !!user,
    //   token: !!token,
    //   hasuraToken: !!hasuraToken,
    //   currentPath: location.pathname
    // });
    // Pass the current location so user can be redirected back after login
    return <Navigate to="/" replace state={{ from: location, requiresAuth: true }} />;
  }

  // Check if user has required user type (if specified)
  if (requiredUserType && !requiredUserType.includes(user.type)) {
    // console.log('ProtectedRoute: Access denied for user type', {
    //   userType: user.type,
    //   requiredTypes: requiredUserType,
    //   currentPath: location.pathname
    // });
    // Redirect to login with access denied state
    return <Navigate to="/" replace state={{ accessDenied: true, userType: user.type, requiredTypes: requiredUserType, fromPath: location.pathname }} />;
  }

  // console.log('ProtectedRoute: Access granted', {
  //   user: user.email,
  //   userType: user.type,
  //   currentPath: location.pathname
  // });

  return <>{children}</>;
};

export default ProtectedRoute;